export const UPDATE_PROFILE = "UPDATE_PROFILE"
export const UPDATE_PROFILE_SUCCESS = "UPDATE_PROFILE_SUCCESS"
export const UPDATE_PROFILE_ERROR = "UPDATE_PROFILE_ERROR"

// get individual user data
export const VIEW_PROFILE = "VIEW_PROFILE"
export const VIEW_PROFILE_SUCCESS = "VIEW_PROFILE_SUCCESS"
export const VIEW_PROFILE_ERROR = "VIEW_PROFILE_ERROR"

